var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87178 9.51297C6.8998 9.29313 6.8998 9.07068 6.87178 8.85084C6.82715 8.50072 6.65947 8.10978 6.17068 7.50115C5.6675 6.87459 4.92386 6.13514 3.83978 5.06068L1.1686 2.41324C0.72285 1.97144 0.71964 1.25195 1.16143 0.806192C1.60323 0.360437 2.32273 0.357229 2.76848 0.799023L5.48779 3.49417C6.51199 4.50923 7.34907 5.33885 7.94271 6.07805C8.56003 6.84672 9.0069 7.62694 9.12627 8.56348C9.17861 8.97412 9.17861 9.38969 9.12627 9.80033C9.0069 10.7369 8.56003 11.5171 7.94271 12.2858C7.34906 13.025 6.51198 13.8546 5.48777 14.8697L2.76848 17.5648C2.32273 18.0066 1.60323 18.0034 1.16143 17.5576C0.71964 17.1119 0.72285 16.3924 1.1686 15.9506L3.83977 13.3031C4.92386 12.2287 5.6675 11.4892 6.17068 10.8627C6.65947 10.254 6.82715 9.86309 6.87178 9.51297Z",
    fill: "#9fa3a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.b0ed4a5402a594da1efb96184ccdad38.svg";
export { ForwardRef as ReactComponent };